import {
  differenceInYears,
  differenceInCalendarMonths,
  parse,
  addYears,
  addMonths,
  getMonth,
} from "date-fns";

(function ($) {
  $(document).ready(() => {
    // MENU

    const body = document.querySelector("body");
    const icoMenuMobile = document.querySelector(".btn-menu-mobile");
    const icoMenuMobileShadow = document.querySelector(".menu-mobile__shadow");
    const menuMobile = document.querySelector(".menu-mobile");
    const icoSearch = document.querySelector(".ico-search");
    const menuSearch = document.querySelector(".bl-header__search");

    if (icoMenuMobile && menuMobile) {
      icoMenuMobile.addEventListener("click", () => {
        body.style.overflow = "hidden";
        menuMobile.classList.toggle("d-none");
      });

      icoMenuMobileShadow.addEventListener("click", () => {
        body.style.overflow = "auto";
        menuMobile.classList.toggle("d-none");
      });
    }

    if (icoSearch && menuSearch) {
      icoSearch.addEventListener("click", () => {
        menuSearch.classList.toggle("d-none");
      });
    }

    // termos

    const terms = document.querySelector(".terms-content");

    if (terms) {
      const termsWpBlockGroup = terms.querySelectorAll(".wp-block-group");

      if (termsWpBlockGroup) {
        termsWpBlockGroup.forEach((term) => {
          const createDivisor = document.createElement("div");
          createDivisor.classList.add("divide-lines");
          createDivisor.setAttribute("style", "position: relative; top: -25px");

          term.prepend(createDivisor);
          const inner = term.querySelector(".wp-block-group__inner-container");
          inner.classList.add("container", "padding-section");
        });
      }
    }

    // CHARTS

    const chartsInPage = document.querySelectorAll(".apexChart");
    const charts = document.querySelectorAll(".chart-values span");

    if (charts) {
      charts.forEach((chart, index, idx) => {
        // if(index != 0) return;

        const splitValues = chart.innerText.split(", ");
        const returnValues = splitValues.map((value, i, ar) => {
          if (i == ar.length - 1) {
            return value.replace(",", "");
          }
          return value;
        });

        const numberValues = returnValues
          .filter((el, i) => i % 2 != 0)
          .map((a) => a.replace(",", "."));
        const stringValues = returnValues.filter((el, i) => i % 2 == 0);

        getBarChartValues(stringValues, numberValues, index);
      });
    }

    function getBarChartValues(stringValues, numberValues, i) {
      if (chartsInPage) {
        const charts = Array.from(chartsInPage);
        const random = Math.floor(Math.random() * 100);
        const id = "id" + random;
        const type = charts[i].dataset.type;
        const color = charts[i].dataset.color;
        const height = charts[i].dataset.height;
        charts[i].classList.add(id);

        if (type == "bar") {
          new BarChart(numberValues, stringValues, id, height, color, type);
        }
      }
    }

    function BarChart(
      numberValues,
      stringValues,
      id,
      height = "auto",
      color = "#0089CA",
      chartType
    ) {
      var options = {
        chart: {
          type: "bar",
          height: height === "auto" ? "auto" : height,
        },
        series: [{ data: numberValues }],
        colors: [color],
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories: stringValues,
          axisBorder: { show: false },
          axisTicks: { show: false },
          labels: {
            style: {
              colors: [
                color,
                color,
                color,
                color,
                color,
                color,
                color,
                color,
                color,
                color,
              ],
            },
          },
        },
        grid: {
          borderColor: "transparent",
        },
        tooltip: { enabled: false },
        yaxis: {
          // max: 16,
          labels: {
            maxWidth: 300,
            style: {
              fontSize: "14px",
              colors: [
                color,
                color,
                color,
                color,
                color,
                color,
                color,
                color,
                color,
                color,
              ],
            },
          },
        },
      };

      const chart = new ApexCharts(document.querySelector("." + id), options);
      chart.render();
    }

    /*
     GENERAL Charts
    */
    const blockBarChart = document.querySelectorAll(".container-chart");

    if (blockBarChart) {
      blockBarChart.forEach((block, i) => {
        const lines = block.querySelectorAll(".block-chart-values span");
        const toArray = Array.from(lines);
        const getTextLines = toArray.map((line) => line.innerText);
        convertToValueChart(getTextLines, i);
      });
    }

    function convertToValueChart(lines, i) {
      const splitValues = lines[0].split(",");
      splitValues.pop();
      const returnValues = splitValues.map((value, index, ar) => {
        if (index == ar.length - 1) {
          return value.replace(",", "");
        }
        return value;
      });

      const numberValues = returnValues
        .filter((el, i) => i % 2 != 0)
        .map((a) => a.replace(",", "."));
      const stringValues = returnValues.filter((el, i) => i % 2 == 0);

      valuesChart(numberValues, stringValues, i);
    }

    function valuesChart(numberValues, stringValues, i) {
      const charts = document.querySelectorAll(".apexChart");

      if (!charts[i]) return;

      const el = charts[i];
      const id = "chart" + el.dataset.id;
      const type = el.dataset.type;

      el.setAttribute("id", id);

      generalDataChart(numberValues, stringValues, id, type);
    }

    function generalDataChart(numberValues, stringValues, id, type) {
      if (type == "barChart") {
        var options = {
          chart: {
            type: "bar",
            height: "180",
          },
          series: [{ data: numberValues }],

          plotOptions: {
            bar: {
              borderRadius: 4,
              horizontal: true,
            },
          },
          dataLabels: { enabled: false },
          xaxis: {
            categories: stringValues,
            axisBorder: { show: false },
            axisTicks: { show: false },
            labels: {
              style: { colors: ["#fff"] },
            },
          },
          grid: {
            borderColor: "transparent",
          },
          tooltip: { enabled: false },
          yaxis: {
            // max: 16,
            labels: {
              maxWidth: 300,
              style: { fontSize: "14px", colors: ["#222"] },
            },
          },
        };

        const chart = new ApexCharts(document.querySelector("#" + id), options);
        chart.render();
      }

      if (type == "pieChart") {
        const numbers = numberValues.map((a) => Number(a));
        var options = {
          series: numbers,
          chart: {
            width: 380,
            type: "pie",
          },
          labels: stringValues,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        };

        const chart = new ApexCharts(document.querySelector("#" + id), options);
        chart.render();
      }
    }

    /*
     Line Charts
    */

    const blockLineDashed = document.querySelectorAll(".block-line-dashed");
    const linechart = document.querySelectorAll(".linechart");

    if (blockLineDashed) {
      blockLineDashed.forEach((block, i) => {
        const lines = block.querySelectorAll(".linechart-values span");
        const toArray = Array.from(lines);
        const getTextLines = toArray.map((line) => line.innerText);
        convertToLinesChart(getTextLines, i);
      });
    }

    function convertToLinesChart(lines, i) {
      const result = lines.map((item, i) => {
        const splitValues = item.split("=");
        const title = splitValues[0];
        const stringValues = splitValues[1].split(", ");

        const values = stringValues.map((value, index, ar) => {
          if (index == ar.length - 1) {
            return value.replace(",", "");
          }
          return value;
        });

        const data = {
          name: title,
          data: values,
        };

        return [data];
      });

      linesChart(result, i);
    }

    function linesChart(result, i) {
      const charts = document.querySelectorAll(".pageCharts");

      if (!charts[i]) return;

      const el = charts[i];
      const id = "chart" + el.dataset.id;
      el.setAttribute("id", id);

      dataChart(id, result);
    }

    function dataChart(id, data) {
      var options = {
        series: data.flat(),
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: [1],
          curve: "straight",
          dashArray: [5, 5, 5, 5],
        },
        legend: {
          tooltipHoverFormatter: function (val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          },
        },
        colors: ["#0089CA", "#809B89", "#4c5d52", "#01547C"],
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6,
          },
        },
        xaxis: {
          categories: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],
        },
        legend: {
          height: 50,
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function (val) {
                  return val + " (mins)";
                },
              },
            },
            {
              title: {
                formatter: function (val) {
                  return val;
                },
              },
            },
          ],
        },
        grid: {
          borderColor: "transparent",
        },
      };

      const renderChart = new ApexCharts(
        document.querySelector(`#${id}`),
        options
      );
      renderChart.render();
    }

    /*
     Negative Charts
    */

    const blockNegativeChart = document.querySelectorAll(".block-bar-negative");
    // const linechart = document.querySelectorAll('.linechart');

    if (blockNegativeChart) {
      blockNegativeChart.forEach((block, i) => {
        const lines = block.querySelectorAll(".bar-negative-values span");
        const toArray = Array.from(lines);
        const getTextLines = toArray.map((line) => line.innerText);
        convertToNegativeChart(getTextLines, i);
      });
    }

    function convertToNegativeChart(lines, i) {
      const result = lines.map((item, i) => {
        const splitValues = item.split("=");
        const title = splitValues[0];
        const stringValues = splitValues[1].split(", ");

        const values = stringValues.map((value, index, ar) => {
          if (index == ar.length - 1) {
            return value.replace(",", "");
          }
          return value;
        });

        const numbers = values.map((a) => Number(a));

        const data = {
          name: title,
          data: numbers,
        };

        return [data];
      });

      negativeChart(result, i);
    }

    function negativeChart(result, i) {
      const charts = document.querySelectorAll(".negativeCharts");

      if (!charts[i]) return;

      const el = charts[i];
      const id = "chart" + el.dataset.id;
      el.setAttribute("id", id);

      dataNegativeChart(id, result);
    }

    function dataNegativeChart(id, data) {
      var options = {
        series: data.flat(),
        chart: {
          type: "bar",
          height: 440,
          stacked: true,
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        grid: {
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        grid: {
          borderColor: "transparent",
        },
        title: {
          text: "",
        },
        xaxis: {
          categories: [
            "85 anos ou mais",
            "de 75 até 84 anos",
            "de 65 até 74 anos",
            "de 55 até 64 anos",
            "de 35 até 54 anos",
            "de 25 até 34 anos",
            "até 24 anos",
          ],
        },
      };

      const renderChart = new ApexCharts(
        document.querySelector(`#${id}`),
        options
      );
      renderChart.render();
    }

    // history

    $(".history-slider").slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 3,
      centerMode: true,
      initialSlide: 1,
      variableWidth: true,
      // arrows: false,
      prevArrow: `
        <button class="slick-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
          </svg>
        </button>
      `,
      nextArrow: `
        <button class="slick-next">
          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" fill="currentColor" class="bi bi-arrow-right-circle" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
          </svg>
        </button>
      `,
    });

    /*
      SIMULADOR
    */

    const formSimulator = document.querySelector(".form-simulator");
    const result = document.querySelector(".accession-form-result");

    const mouths = [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ];

    if (formSimulator) {
      formSimulator.addEventListener("submit", (e) => {
        e.preventDefault();

        if (!validateForm()) {
          return;
        }

        valideRetireAge();

        result.classList.remove("d-none");

        const dayBirth =
          formSimulator.dayBirth.value < 10
            ? "0" + formSimulator.dayBirth.value
            : formSimulator.dayBirth.value;
        const mouthBirth =
          formSimulator.mouthBirth.value < 10
            ? "0" + formSimulator.mouthBirth.value
            : formSimulator.mouthBirth.value;
        const birthDate =
          dayBirth + "/" + mouthBirth + "/" + formSimulator.yearBirth.value;

        const dayAdmis =
          formSimulator.dayAdmis.value < 10
            ? "0" + formSimulator.dayAdmis.value
            : formSimulator.dayAdmis.value;
        const mouthAdmis =
          formSimulator.mouthAdmis.value < 10
            ? "0" + formSimulator.mouthAdmis.value
            : formSimulator.mouthAdmis.value;
        const admisDate =
          dayAdmis + "/" + mouthAdmis + "/" + formSimulator.yearAdmis.value;

        const object = {
          birthdate: birthDate,
          admissionDate: admisDate,
          salary: convertToDecimal(formSimulator.salary.value),
          retireAge: +formSimulator.customRange1.value,
          receiveTime: +formSimulator.customRange2.value,
          contributionPercentage:
            formSimulator.faixa.value == "basic"
              ? "basic"
              : formSimulator.faixa.value == "risk"
              ? "risk"
              : +formSimulator.faixa.value, // basic, risk, or 0.1 to 1.0 values
          up: +formSimulator.up.value,
          riskPercentage: +formSimulator.percent.value,
          facap: +formSimulator.facap.value,
          anualRentability: +formSimulator.yearRent.value,
        };

        calculate(object);
      });

      init();
    }

    function validateForm() {
      if (formSimulator.salary.value < 1) {
        alert("Preencha o salário");
        return false;
      }

      return true;
    }

    function init() {
      createDays(formSimulator.dayBirth);
      createDays(formSimulator.dayAdmis);

      createMonths(formSimulator.mouthBirth);
      createMonths(formSimulator.mouthAdmis);

      createYears(formSimulator.yearBirth, 76);
      createYears(formSimulator.yearAdmis, 71);

      calculateRetirementAge();

      $(".salary").mask("#.##0,00", { reverse: true });
    }

    function calculateRetirementAge() {
      const year = new Date().getFullYear();
      formSimulator.yearBirth.value = 1949;
      formSimulator.yearAdmis.value = 2019;

      const age = year - formSimulator.yearBirth.value;

      formSimulator.yearBirth.addEventListener("change", (e) => {
        const ageInAdmis = formSimulator.yearAdmis.value - e.target.value;
        const age = year - e.target.value;

        const minAgeForAdmin = ageInAdmis + 3;

        if (minAgeForAdmin < 50) {
          calculateAge(50);
          return;
        }

        if (minAgeForAdmin < age) {
          calculateAge(age);
          return;
        }

        calculateAge(minAgeForAdmin);
      });

      formSimulator.yearAdmis.addEventListener("change", (e) => {
        const ageInAdmis = e.target.value - formSimulator.yearBirth.value;
        const age = year - formSimulator.yearBirth.value;

        const minAgeForAdmin = ageInAdmis + 3;

        if (minAgeForAdmin < 50) {
          calculateAge(50);
          return;
        }

        if (minAgeForAdmin < age) {
          calculateAge(age);
          return;
        }

        calculateAge(minAgeForAdmin);
      });

      calculateAge(
        formSimulator.yearAdmis.value - formSimulator.yearBirth.value + 3
      );
    }

    function calculateAge(age = 50) {
      formSimulator.customRange1.min = age;
      formSimulator.customRange1.value = age;
      document.querySelector(".rangeValue1").innerHTML = age + " anos";

      const maxAge = +age + 20;
      formSimulator.customRange1.max = maxAge;
    }

    function valideRetireAge() {
      if (
        +formSimulator.customRange1.value ==
        formSimulator.customRange1.max - 20
      ) {
        var myModal = new bootstrap.Modal(document.getElementById("modalForm"));

        myModal.show();
      }
    }

    // detalhes dos campos

    const rangeGroup = document.querySelectorAll(".rangeGroup");

    if (rangeGroup) {
      rangeGroup.forEach((range) => {
        const inputRange = range.querySelector("input");
        const spanRange = range.querySelector("span");

        inputRange.addEventListener("change", (e) => {
          const value = Number(e.target.value);
          spanRange.innerText = value === 1 ? value + " ano" : value + " anos";
          inputRange.setAttribute("value", value);
        });
      });
    }

    function createDays(element) {
      for (let i = 1; i <= 31; i++) {
        const optionDays = document.createElement("option");
        optionDays.setAttribute("value", i);
        optionDays.innerHTML = i;
        element.appendChild(optionDays);
      }
    }

    function createMonths(element) {
      for (let i = 0; i < 12; i++) {
        const optionMouths = document.createElement("option");
        optionMouths.setAttribute("value", i + 1);
        optionMouths.innerHTML = mouths[i];
        element.appendChild(optionMouths);
      }
    }

    function createYears(element, number) {
      const year = new Date().getFullYear();
      for (let i = year; i >= year - number; i--) {
        const optionMouths = document.createElement("option");
        optionMouths.setAttribute("value", i);
        optionMouths.innerHTML = i;
        element.appendChild(optionMouths);
      }
    }

    let total = {
      base: 0,
      additional: 0,
      risk: 0,
      total: 0,
      acc: 0,
      initial: 0,
    };

    let ownerContribution = {
      base: 0,
      additional: 0,
      risk: 0,
      total: 0,
      acc: 0,
      initial: 0,
    };

    let companyContribution = {
      base: 0,
      additional: 0,
      risk: 0,
      total: 0,
      acc: 0,
      initial: 0,
    };

    const calculate = (params) => {
      total = {
        base: 0,
        additional: 0,
        risk: 0,
        total: 0,
        acc: 0,
        initial: 0,
      };

      ownerContribution = {
        base: 0,
        additional: 0,
        risk: 0,
        total: 0,
        acc: 0,
        initial: 0,
      };

      companyContribution = {
        base: 0,
        additional: 0,
        risk: 0,
        total: 0,
        acc: 0,
        initial: 0,
      };

      if (params.contributionPercentage === "basic") {
        params.contributionPercentage = 0;
      }
      params.birthdate = parse(params.birthdate, "dd/MM/yyyy", new Date());
      params.admissionDate = parse(
        params.admissionDate,
        "dd/MM/yyyy",
        new Date()
      );

      console.log("Params", params);

      if (params.contributionPercentage !== "risk") {
        calculateOwnerBaseContribution(params);
        calculateOwnerAdditionalContribution(params);
      }
      calculateOwnerRiskContribution(params);
      calculateCompanyContribution();
      calculateOwnerAcc(params);
      calculateCompanyAcc(params);
      calculateTotal();
      const result = { ownerContribution, companyContribution, total };

      console.log("Result");
      console.log(result);

      renderHtml(
        ".basicParticipantContribution",
        result.ownerContribution.base
      );
      renderHtml(
        ".additionalParticipantContribution",
        result.ownerContribution.additional
      );
      renderHtml(
        ".participantsRiskContribution",
        result.ownerContribution.risk
      );
      renderHtml(".totalParticipant", result.ownerContribution.total);
      renderHtml(".mountAcc", result.ownerContribution.acc);
      renderHtml(".mountInitial", result.ownerContribution.initial);

      renderHtml(".sponsorsBasicContribution", result.companyContribution.base);
      renderHtml(
        ".sponsorsAdditionalContribution",
        result.companyContribution.additional
      );
      renderHtml(".sponsorsRiskContribution", result.companyContribution.risk);
      renderHtml(".totalSponsors", result.companyContribution.total);
      renderHtml(".mountSponsors", result.companyContribution.acc);
      renderHtml(".mountInitialSponsors", result.companyContribution.initial);

      renderHtml(".basicParticipantTotal", result.total.base);
      renderHtml(".totalParticipantAdditional", result.total.additional);
      renderHtml(".totalRiskContribution", result.total.risk);
      renderHtml(".total", result.total.total);
      renderHtml(".mountTotal", result.total.acc);
      renderHtml(".mountTotalSponsors", result.total.initial);

      return result;
    };

    const calculateOwnerBaseContribution = ({ salary, up }) => {
      if (salary < up * 10) {
        ownerContribution.base = normalizeResult(salary * 0.01);
      } else {
        ownerContribution.base = normalizeResult(
          salary * 0.05 - up * 10 * 0.04
        );
      }
    };

    const calculateOwnerAdditionalContribution = (params) => {
      ownerContribution.additional = normalizeResult(
        ownerContribution.base * params.contributionPercentage
      );
    };

    const calculateOwnerRiskContribution = (params) => {
      if (params.contributionPercentage === "risk" || getAge(params) < 55) {
        const base =
          params.salary < params.up * 10
            ? params.salary * 0.01
            : params.salary * 0.05 - params.up * 10 * 0.04;
        ownerContribution.risk = normalizeResult(
          base * 2 * params.riskPercentage
        );
      }
    };

    const calculateOwnerAcc = ({
      anualRentability,
      facap,
      birthdate,
      retireAge,
      receiveTime,
    }) => {
      const base = ownerContribution.base;
      const additional = ownerContribution.additional;
      const risk = ownerContribution.risk;
      ownerContribution.total = normalizeResult(base + additional + risk);
      const monthlyTax = (1 + anualRentability / 100) ** (1 / 12);
      const months = getContributionMonths({ birthdate, retireAge }) - 1;
      for (let actual = 0; actual <= months; actual++) {
        const actualMonth = getMonth(addMonths(new Date(), actual)) + 1;
        const decemberTax = actualMonth === 12 ? 2 : 1;
        const monthlyValue = (base + additional) * decemberTax;
        ownerContribution.acc +=
          monthlyValue * monthlyTax ** (months - actual) * facap;
      }
      ownerContribution.initial = normalizeResult(
        ownerContribution.acc / (receiveTime * 13)
      );
      ownerContribution.acc = normalizeResult(ownerContribution.acc);
    };

    const calculateCompanyAcc = ({
      anualRentability,
      facap,
      birthdate,
      retireAge,
      receiveTime,
    }) => {
      const base = companyContribution.base;
      const additional = companyContribution.additional;
      const risk = companyContribution.risk;
      companyContribution.total = normalizeResult(base + additional + risk);
      const monthlyTax = (1 + anualRentability / 100) ** (1 / 12);
      const months = getContributionMonths({ birthdate, retireAge }) - 1;
      for (let actual = 0; actual <= months; actual++) {
        const actualMonth = getMonth(addMonths(new Date(), actual)) + 1;
        const decemberTax = actualMonth === 12 ? 2 : 1;
        const monthlyValue = (base + additional) * decemberTax;
        companyContribution.acc +=
          monthlyValue * monthlyTax ** (months - actual) * facap;
      }
      companyContribution.initial = normalizeResult(
        companyContribution.acc / (receiveTime * 13)
      );
      companyContribution.acc = normalizeResult(companyContribution.acc);
    };

    const calculateCompanyContribution = () => {
      companyContribution.base = ownerContribution.base;
      companyContribution.additional = normalizeResult(
        ownerContribution.additional * 0.5
      );
      companyContribution.risk = ownerContribution.risk;
    };

    const calculateTotal = () => {
      total.base = normalizeResult(
        ownerContribution.base + companyContribution.base
      );
      total.additional = normalizeResult(
        ownerContribution.additional + companyContribution.additional
      );
      total.risk = normalizeResult(
        ownerContribution.risk + companyContribution.risk
      );
      total.total = normalizeResult(
        ownerContribution.total + companyContribution.total
      );
      total.acc = normalizeResult(
        ownerContribution.acc + companyContribution.acc
      );
      total.initial = normalizeResult(
        ownerContribution.initial + companyContribution.initial
      );
    };

    const getContributionMonths = ({ birthdate, retireAge }) =>
      differenceInCalendarMonths(addYears(birthdate, retireAge), new Date());
    const getAge = ({ birthdate }) => differenceInYears(new Date(), birthdate);
    const normalizeResult = (value) => Math.round(value * 100) / 100;

    function renderHtml(el, value) {
      document.querySelector(el).innerHTML = value.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    }

    function convertToDecimal(number) {
      const value = number.replace(".", "").replace(",", ".");
      return parseFloat(value);
    }

    // categories is text separed with commas and remove
    const getGraphCategories = document.querySelector(".graph-categories");
    const chartCategories = getGraphCategories
      ? getGraphCategories.innerText.split(",")
      : [];
    chartCategories.pop();

    const getGraphValues = document.querySelector(".graph-values");
    const chartValues = getGraphValues
      ? getGraphValues.innerText.split(",")
      : [];
    chartValues.pop();

    var options = {
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      series: [
        {
          name: "Soma(%)",
          data: chartValues,
        },
      ],
      colors: ["#0e4d6e"],
      plotOptions: {
        bar: {
          borderRadius: 4,
          horizontal: false,
          columnWidth: "60%",
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: chartCategories,
        labels: {
          style: {
            fontSize: "12px",
            colors: "#666",
          },
        },
      },
      yaxis: {
        title: {
          text: "Soma(%)",
          style: {
            fontSize: "14px",
            fontWeight: 600,
            color: "#666",
          },
        },
        labels: {
          formatter: function (val) {
            return val;
          },
          style: {
            fontSize: "12px",
            colors: "#666",
          },
        },
      },
      grid: {
        borderColor: "#e0e0e0",
        strokeDashArray: 3,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val + "%";
          },
        },
      },
    };

    var chart = new ApexCharts(
      document.querySelector("#rentabilidadeBarChart"),
      options
    );
    chart.render();
  });
})(jQuery);
